import React from "react";
import { ISliderInput } from "Interfaces/interface.mockupGenerator";

const SliderInput: React.FC<ISliderInput> = ({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  unit = "",
  icon: Icon,
}) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4 text-gray-600" />}
        <label className="text-sm font-semibold text-gray-700">{label}</label>
      </div>
      <span className="text-xs font-mono text-gray-600 bg-gray-100 px-2 py-1 rounded-md">
        {value?.toFixed(step < 1 ? 2 : 0) || "0"}
        {unit}
      </span>
    </div>
    <input
      type="range"
      min={min}
      max={max}
      step={step}
      value={value || min}
      onChange={(e) => onChange(parseFloat(e.target.value))}
      className="w-full h-2 bg-gradient-to-r from-indigo-300 to-purple-300 rounded-lg cursor-pointer accent-indigo-600"
    />
  </div>
);

export default SliderInput;
